/**
 * @module components\ghTable\dataTable
 */
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Model } from "vue-property-decorator";

@Component
export default class TableProperty extends Vue {
  @Model("input")
  protected value!: object[];

  @Prop()
  protected events!: string[];
  @Prop()
  protected headers!: ITableHeader[];

  @Prop()
  protected currentModel!: object;

  @Prop()
  protected items!: any[];

  @Prop({ default: false })
  protected hideActions!: boolean;

  @Prop({ default: true })
  protected selectAll!: boolean;

  @Prop({ default: undefined })
  protected customFilter!: (
    items: object[],
    search: string,
    filter
  ) => object[];

  @Prop({ default: undefined })
  protected customSort!: (
    items: object[],
    index: number,
    isDescending: boolean
  ) => object[];

  @Prop({ default: undefined })
  protected dark!: boolean;

  @Prop({ default: undefined })
  protected disableInitialSort!: boolean;

  @Prop({ default: false })
  protected expand!: boolean;

  @Prop({ default: undefined })
  protected filter: (val: object, search: string) => boolean;

  @Prop({ default: undefined })
  protected headerKey;

  @Prop({ default: undefined })
  protected headerText;

  @Prop({ default: undefined })
  protected headersLength!: any;

  @Prop({ default: false })
  protected hideHeaders!: boolean;

  @Prop({ default: "Id" })
  protected itemKey!: string;

  @Prop({ default: false })
  protected light!: boolean;

  @Prop({ default: false })
  protected loading!: boolean;

  @Prop({ default: false })
  protected mustSort!: boolean;

  @Prop({ default: undefined })
  protected nextIcon!: string;

  @Prop({ default: undefined })
  protected totalItems!: number;

  @Prop({ default: undefined })
  protected search!: any;

  @Prop({ default: () => [10, 20, 50, 100, 500] })
  protected rowsPerPageItems!: object[];

  @Prop()
  protected pagination!: IPagination;

  protected tableEvents = ["input", "update:pagination"];

  protected traceAction(
    headers?: ITableHeader[],
    actionCallback?: (item: IRowAction) => void
  ) {
    let hds = this.headers;
    if (headers) {
      hds = headers;
    }

    for (const header of hds) {
      if (header.actions && header.actions.length > 0) {
        for (const action of header.actions) {
          if (actionCallback) {
            actionCallback(action);
          }
        }
      }
    }
  }
}
